const getData = function(params) {
    if (window.sitePageAutoInit === false) {
        return import(
            /* webpackChunkName: "market_trends_mock"*/ './cms-mock'
        ).then(res => {
            //  right   result in a deep copy 
            return Promise.resolve(JSON.parse(JSON.stringify(res)));
        });
    }
    return this.axiosIns.get('/api-site/snapshot/soldPriceStat', { params });
};
export default {
    getData: getData
};
